import React from 'react';
import {
  Elements,
  StripeProvider,
} from 'react-stripe-elements';
import {
  Link,
} from 'react-router-dom';

import bookCover from 'web-assets/images/Book_Cover_Mockup-V2B.png';

import config from 'web-config';
import {
  Tooltip,
  SetNamespace,
} from 'web-components';
import {
  Flex,
  Text,
} from 'web-styled';

import CheckoutForm from './CheckoutForm';
import * as S from './styled';

const HTSSignUp = () => {
  const ThreeSections = (className) => (
    <S.ThreeSections className={className}>
      <Tooltip
        body="Secure transaction to ensure your information is safe."
        positions={['top']}
      >
        <Flex
          column
          width="33.33333333%"
          justify="center"
          padding="25px 0"
          align="center"
          spacing={10}
        >
          <span className="symbol01" />
          <p>
            AES-256bit
            <br />
            Encryption
          </p>
        </Flex>
      </Tooltip>
      <Tooltip
        body="We will not share or trade online information that you provide us."
        positions={['top']}
      >
        <Flex
          column
          width="33.33333333%"
          justify="center"
          padding="25px 0"
          align="center"
          spacing={10}
        >
          <span className="symbol02" />
          <p>
            Gymcloud, LLC
            <br />
            Protects Your
            <br />
            Privacy
          </p>
        </Flex>
      </Tooltip>
      <Tooltip
        body="All personal information is encrypted and secure."
        positions={['top']}
      >
        <Flex
          column
          width="33.33333333%"
          justify="center"
          padding="25px 0"
          align="center"
          spacing={10}
        >
          <span className="symbol03" />
          <p>
            Your
            <br />
            Information
            <br />
            is Secure
          </p>
        </Flex>
      </Tooltip>
    </S.ThreeSections>
  );

  return (
    <S.MainContainer>
      <S.Wrapper height="358px" />
      <S.CheckoutContainer>
        <S.CheckoutMiddleContainer>
          <S.AboutProduct>
            <S.ProdctImage>
              <img src={bookCover} alt="" />
            </S.ProdctImage>
            <hgroup>
              <Text color="#000" size="32px">
                Hybrid Training System
              </Text>
            </hgroup>
          </S.AboutProduct>
          <S.FormContainer>
            <Flex column width="calc(100% - 390px)">
              <StripeProvider
                apiKey={config.stripe.key}
              >
                <Elements>
                  <CheckoutForm />
                </Elements>
              </StripeProvider>

              <Flex
                spacing={3}
                width="100%"
                justify="center"
                align="center"
                padding="10px"
              >
                <Text color="#a6a7aa" size="14px">
                  Already have an account?
                </Text>
                <Link to="/login">Sign in</Link>
              </Flex>

              {process.env.TARGET_ENV !== 'production' && (
                <Flex
                  width="100%"
                  margin="-10px 0px 10px 0px"
                  justify="center"
                >
                  <SetNamespace />
                </Flex>
              )}
            </Flex>
            <Flex column>
              <S.WhatsInside>
                <Text size="25px" as="h3">
                  With the Hybrid Training System, you&apos;ll also get access to these
                  FREE BONUS resources specifically designed to help you succeed...
                </Text>
                <Flex column spacing={10}>
                  <p>
                    <b>
                      <u>
                        6 Week Masterclass,
                      </u>
                    </b>
                    {' '}
                    weekly 60 minute lessons
                  </p>
                  <p>
                    <b>
                      <u>
                        Premium Exercise Videos,
                      </u>
                    </b>
                    {' '}
                    so clients know exactly what to do - and how to do it safely
                  </p>
                  <p>
                    <b>
                      <u>
                        Science-Based Workout and Program Templates
                      </u>
                    </b>
                    {' '}
                    to help you save time on program design
                  </p>
                  <p>
                    <b>
                      <u>
                        Unlimited access
                      </u>
                    </b>
                    {' '}
                    to the GymCloud 3-client subscription
                  </p>
                </Flex>
              </S.WhatsInside>
              {ThreeSections('desktop')}
            </Flex>
          </S.FormContainer>
          {ThreeSections('mobile')}
        </S.CheckoutMiddleContainer>
      </S.CheckoutContainer>
      <S.Wrapper height="230px" margin="-70px 0 0" />
    </S.MainContainer>
  );
};

export default HTSSignUp;
